import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const DataTypeFloat = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M15 20h2v2h-2v-2Z" />
		<path fillRule="evenodd" clipRule="evenodd" d="M20 21V11h1v10h-1Z" />
		<path fillRule="evenodd" clipRule="evenodd" d="M17 14h10v1H17v-1Z" />
		<path fillRule="evenodd" clipRule="evenodd" d="M23 21V11h1v10h-1Z" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17 17h10v1H17v-1ZM8 21V11h1v10H8Z"
		/>
		<path fillRule="evenodd" clipRule="evenodd" d="M5 14h10v1H5v-1Z" />
		<path fillRule="evenodd" clipRule="evenodd" d="M11 21V11h1v10h-1Z" />
		<path fillRule="evenodd" clipRule="evenodd" d="M5 17h10v1H5v-1Z" />
	</svg>
);

export default DataTypeFloat;
